import type { FormEvent } from "react";

export function Banner({ error, note }: { error?: string | null; note?: string | null }) {
  if (error) return <p className="banner error" role="alert">{error}</p>;
  if (note) return <p className="banner ok">{note}</p>;
  return null;
}

export function messageOf(reason: unknown): string {
  return reason instanceof Error ? reason.message : "Κάτι πήγε στραβά.";
}

export function onSubmit(handler: (body: Record<string, string>) => Promise<void>) {
  return (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    const body: Record<string, string> = {};
    form.forEach((value, key) => {
      body[key] = String(value);
    });
    void handler(body);
  };
}
